
export const deleteAttributeAction = ( attribute_data ) => {
    return { type: "ATTRIBUTE:DELETE_ATTRIBUTE", attribute_data }
}

export const loadAttributesConstantsAction = ( constants ) => {
    return { type: "ATTRIBUTES:LOAD_CONSTANTS", constants }
}
